import { adminMutation } from "@/admin/utils/adminMutation.ts";
import { jsonEncodedBody } from "@/utils/fetchClient.ts";
import type { QueryKey } from "@tanstack/react-query";
import type { VmImage, VmImageOrderResponse } from "@warrenio/api-spec/spec.oats.gen";

export type VmImageType = "app_catalog" | "plain_os";

//#region Query and parameters
const queryKey: QueryKey = ["vm_images"];

//#region Mutations

const entity = "VM image";

export const vmImageCreateMutation = adminMutation((apiClient) => ({
    entity,
    operation: "create",
    requestFn: async ({ body, image_type }: { image_type: VmImageType; body: VmImage }) =>
        await apiClient.POST("/config/vm_images/{image_type}", {
            params: { path: { image_type } },
            ...jsonEncodedBody,
            body,
        }),
    invalidateQueryKey: queryKey,
}));

export const vmImageUpdateMutation = adminMutation((apiClient) => ({
    entity,
    operation: "update",
    requestFn: async ({
        os_name,
        image_type,
        body,
    }: {
        os_name: VmImage["os_name"];
        image_type: VmImageType;
        body: VmImage;
    }) =>
        await apiClient.PATCH("/config/vm_images/{image_type}/{os_name}", {
            params: { path: { image_type, os_name } },
            ...jsonEncodedBody,
            body,
        }),
    invalidateQueryKey: queryKey,
}));

export const vmImageDeleteMutation = adminMutation((apiClient) => ({
    entity,
    operation: "delete",
    requestFn: async ({ os_name, image_type }: { os_name: VmImage["os_name"]; image_type: VmImageType }) =>
        await apiClient.DELETE("/config/vm_images/{image_type}/{os_name}", {
            params: { path: { image_type, os_name } },
        }),
    invalidateQueryKey: queryKey,
}));

export const vmImageOrderMutation = adminMutation((apiClient) => ({
    entity,
    operation: "order",
    requestFn: async ({ image_type, body }: { image_type: VmImageType; body: VmImageOrderResponse }) =>
        await apiClient.PUT("/config/vm_images_order/{image_type}", {
            params: { path: { image_type } },
            ...jsonEncodedBody,
            body,
        }),
    invalidateQueryKey: queryKey,
}));

//#endregion Mutations
